module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/genova.09c3512afb9be11448d1ae5de4942aa2.jpg";